<div class="container">
    <form [formGroup]="formulario">

        <div class="row pt-1">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Criação De</mat-label>
                    <input matInput id="txtCreateIniDt" #txtCreateIniDt maxlength="10" mask="d0/M0/0000"
                        formControlName="created_at_inicial">
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                    <mat-hint align="end">{{txtCreateIniDt.value.length}} / 10</mat-hint>
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Criação Até</mat-label>
                    <input matInput id="txtCreateFinDt" #txtCreateFinDt maxlength="10" mask="d0/M0/0000"
                        formControlName="created_at_final">
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                    <mat-hint align="end">{{txtCreateFinDt.value.length}} / 10</mat-hint>
                </mat-form-field>
            </div>
        </div>
        <div class="row pt-3">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Safra</mat-label>
                    <mat-select formControlName="safra" multiple>
                        <mat-option *ngFor="let item of filteredOptionsSafra | async" [value]="item.name">
                            {{item.name | uppercase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Site Beneficiamento</mat-label>
                    <input matInput #txtSite maxlength="15" formControlName="site" [matAutocomplete]="auto" readonly
                        class="InputBlockColor">
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let item of filteredOptionsSite | async" [value]="item.initials">
                            {{item.initials | uppercase}}
                        </mat-option>
                    </mat-autocomplete>
                    <i matSuffix class="{{iconDisableField}}"></i>
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                    <mat-hint align="end">{{txtSite.value?.length || 0}}/15</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div class="row pt-1">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Peneira</mat-label>
                    <mat-select formControlName="peneira" multiple>
                        <mat-option *ngFor="let item of filteredOptionsPeneira | async" [value]="item.name">
                            {{item.name | uppercase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                    floatLabel="{{ formFieldFloatLabel }}">
                    <mat-label class="InputLabelColor">Híbrido</mat-label>
                    <mat-select #txtHibrido formControlName="hibrido" disableCenteringOption>
                        <input matInput type="text" class="form-control filterTxt"
                            placeholder="Pesquisar por..."
                            (keyup)="createFilterHibrido($event.target.value)">
                        <mat-option *ngFor="let item of listHibrido" [value]="item.name">{{ item.name |
                            uppercase }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row pt-3">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Usuário</mat-label>
                    <mat-select formControlName="usuario" multiple>
                        <mat-option *ngFor="let item of filteredOptionsUsuario | async" [value]="item.name">
                            {{item.name | uppercase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Status</mat-label>
                    <mat-select name="status" formControlName="is_incomplete" disableOptionCentering>
                        <mat-option *ngFor="let item of listStatus" [value]="item.value">
                            {{item.value ? 'INCOMPLETO ' : 'COMPLETO'}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row pt-1">
            <div class="col-lg-12 col-md-12" *ngIf="areaSelect.includes('Básica')">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Número do Campo
                    </mat-label>
                    <input matInput id="txtNumeroCampo" #txtNumeroCampo maxlength="20" currencyMask
                        [options]="{ thousands: '', decimal: '', precision: 0 }" formControlName="numero_campo">
                    <i matSuffix class="{{iconEnableField}}"></i>
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>

                </mat-form-field>
            </div>
            <div class="col-lg-12 col-md-12" *ngIf="!areaSelect.includes('Básica')">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Número Controle</mat-label>
                    <input matInput #txtNumControle maxlength="10" formControlName="numero_controle" appOnlyNumber
                        [matAutocomplete]="auto5">
                    <mat-autocomplete #auto5="matAutocomplete">
                        <mat-option *ngFor="let item of filteredOptionsNum | async" [value]="item.name">
                            {{item.name | uppercase}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                    <mat-hint align="end">{{txtNumControle.value?.length || 0}}/10</mat-hint>
                </mat-form-field>
            </div>
        </div>
        <div class="row pt-2">
            <div class="col-lg col-md text-right">
                <button mat-flat-button color="primary" matTooltip="Limpar" class="textoGeral mr-1"
                    (click)="clearFilter()"><i class="fa fa-paint-brush" aria-hidden="true"></i> Limpar</button>
                <button mat-flat-button color="primary" matTooltip="Pesquisar" class="textoGeral mr-1"
                    (click)="sendFilter()"><i class="fa fa-search" aria-hidden="true"></i> Pesquisar</button>
            </div>
        </div>
    </form>
</div>